<template>
  <div v-if="id != ''" class="card" @click="toPreview">
    <div class="store-info">
      <img :src="bgImg" alt="" />
      <div style="display: flex; align-items: baseline">
        {{ name }}
        <span :class="enable == 0 ? 'classa' : 'classb'">{{
          enable == 0 ? "已下架" : "已上架"
        }}</span>
        <div>（权重：{{ orderIndex }}）</div>
      </div>
      <div class="remark">
        {{ remark }}
      </div>
    </div>
    <div class="name">
      <el-popover placement="bottom" :width="80" trigger="hover">
        <template #reference>
          <div class="delete">...</div>
        </template>
        <div class="other-options">
          <div class="option" @click.stop="toEdit">编辑</div>
          <div class="option" @click.stop="onShelvesShop" v-if="enable === 0">
            上架
          </div>
          <div class="option" @click.stop="offShelvesShop" v-if="enable === 1">
            下架
          </div>
          <div class="option" @click.stop="deleteTemplate">删除</div>
        </div>
      </el-popover>
    </div>
  </div>
  <div v-else class="card" @click="toCreated">
    <i class="add iconfont icon-icon_add" />
    <div class="blank-template" style="color: var(--main-text)">
      <span>新增应用</span>
    </div>
  </div>
</template>

<script>
// import { renameTemplate } from '../../../API/template'
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    bgImg: {
      type: String,
      default: ''
    },
    orderIndex: {
      type: Number,
      default: 0
    },
    remark: {
      type: String,
      default: ''
    },
    enable: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    toCreated () {
      this.$router.push({
        path: '/application-config/created/null'
      })
    },
    deleteTemplate () {
      this.$confirm('删除后无法复原', '确认删除当前方案', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$emit('deleteTemplate', this.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 上架
    async onShelvesShop () {
      this.$confirm('确定要上架此应用吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$emit('onShelvesShop', this.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 下架
    async offShelvesShop () {
      this.$confirm('确定要下架此应用吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$emit('offShelvesShop', this.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下架'
        })
      })
    },
    toPreview () {

    },
    toEdit () {
      // if (this.enable === 1) {
      //   this.$confirm('已发布的应用无法编辑，请先下架应用', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(async () => {
      //     this.$emit('offShelvesShop', this.id, 'toEdit')
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消下架'
      //     })
      //   })
      //   return
      // }
      this.$router.push({
        path: `/application-config/edit/${this.id ? this.id : null}`
      })
    }
  }
}
</script>
<style lang="less">
.classa {
  color: #aeb2ba;
  background: rgba(174, 178, 186, 0.1);
}
.classb {
  color: #29c692;
  background: rgba(41, 198, 146, 0.1);
}
</style>
<style lang="less" scoped>
.other-options {
  background: #fff;
  margin: -12px;
  .option {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 13px;
    font-size: 11px;
    cursor: pointer;
    &:hover {
      background: #dde4f0;
    }
  }
}
.card {
  cursor: pointer;
  width: 291px;
  height: 148px;
  background: var(--white);
  border-radius: 4px;
  position: relative;
  margin-right: 12px;
  object-fit: fill;
  margin-bottom: 13px;
  background-size: 100% 100%;
  .add {
    position: absolute;
    left: 28px;
    top: 34px;
    font-size: 36px;
    color: var(--main-text);
  }
  .blank-template {
    position: absolute;
    left: 28px;
    bottom: 25px;
    font-size: 16px;
  }
  .store-info {
    color: var(--main-text);
    padding-top: 32px;
    font-size: 16px;
    margin-left: 34px;
    span {
      margin-top: 12px;
      display: inline-block;
      font-size: 14px;
    }
    img {
      width: 48px;
      height: 48px;
    }
  }
  .name {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 44px;
    border-radius: 0px 0px 4px 4px;
    .delete {
      font-size: 28px;
      position: absolute;
      left: 245px;
      bottom: 7px;
      display: flex;
      line-height: 12px;
      height: 32px;
      width: 32px;
      justify-content: center;
      align-content: center;
      border-radius: 2px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
    span {
      font-size: 16px;
      position: absolute;
      left: 26px;
      bottom: 14px;
    }
  }
  .remark {
    color: #646a77;
    font-size: 12px;
    margin-top: 6px;
  }
}
</style>
